import { isDev, isStage } from '../../../../../modules/Util/S/Function/enviroment';

export const getMembershipFaqUrl = (is_creator?: boolean) => {
  if (is_creator) {
    return `/${ET.lang}/@/help?type=creator_mall_faq_kr&hg_id=540`;
  } else {
    return `/${ET.lang}/@/help?type=creator_mall_customer_faq_kr&hg_id=541`;
  }
};

export const getCietyUrl = (path: string) => {
  if (isDev() || isStage() || process.env.NODE_ENV === 'staging') {
    return `https://ciety.dev${path}`;
  }

  return `https://ciety.xyz${path}`;
};
